import React, { useState, useContext } from 'react';
import { useMutation } from '@tanstack/react-query';
import { AuthContext } from 'components/user/AuthContext';
import { ReferrerContext } from 'components/layout/ReferrerContext';
import { NavigationUtils } from 'lib/navigationUtilities';
import FormContainer from 'components/layout/FormContainer';
import Button from 'components/element/Button';
import Input from 'components/element/Input';
import api from 'lib/api';

const LoginForm = () => {
  const { handleLogin } = useContext(AuthContext);
  const { referrer } = useContext(ReferrerContext);
  const { navigateToLocation } = NavigationUtils();
  const [errorMessage, setErrorMessage] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
  const [credentials, setCredentials] = useState({ login: '', password: '' });

  const loginMutation = useMutation({
    mutationFn: api.auth.login,
    onSuccess: (data) => {
      setErrorMessage('');
      setFieldErrors({});
      handleLogin(data.token);
      navigateToLocation(referrer || '/');
    },
    onError: (error) => {
      console.error('Login error:', error);
      if (error.response?.data?.errors) {
        setFieldErrors(error.response.data.errors);
      } else {
        setErrorMessage(
          error.response?.data?.message || error.message || 'Login failed'
        );
      }
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setFieldErrors({});
    setErrorMessage('');
    loginMutation.mutate(credentials);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({ ...prev, [name]: value }));
    if (fieldErrors[name]) {
      setFieldErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleCloseAlert = () => {
    setErrorMessage('');
  };

  return (
    <FormContainer title="Login to Your Account" errorMessage={errorMessage} onCloseAlert={handleCloseAlert} >
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="p-4 bg-gray-weak rounded-lg border border-gray-mid space-y-4">
          <Input type="text" name="login" value={credentials.login} onChange={handleChange} placeholder="Enter your login" label="Login" error={fieldErrors.login} className="w-full py-2.5" required />
          <Input type="password" name="password" value={credentials.password} onChange={handleChange} placeholder="Enter your password" label="Password" error={fieldErrors.password} className="w-full py-2.5" required />

          <Button type="submit" isLoading={loginMutation.isPending} disabled={loginMutation.isPending} className="w-full py-2.5 text-white bg-blue-mid hover:bg-blue-more" >
            Log In
          </Button>
        </div>
      </form>
    </FormContainer>
  );
};

export default LoginForm;
